<template>
  <span>
    <v-tooltip bottom color="primary">
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          class="primary text--white"
          v-on="{ ...tooltip }"
          @click="dialog = !dialog"
        >
          <v-icon left>mdi-plus</v-icon>Add User
        </v-btn>
      </template>
      <span>Create a new user account.</span>
    </v-tooltip>

    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">delete</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Create New User Account</span
          >
        </v-card-title>

        <v-card-text class="pt-4">
          <v-form v-model="form_is_valid">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="full_name"
                    dense
                    label="Full Name"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    dense
                    label="Email"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="institution"
                    dense
                    label="Institution"
                    :rules="[rules.required]"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password ? 'text' : 'password'"
                    dense
                    label="Password"
                    :rules="[rules.required, rules.minlen]"
                    @click:append="show_password = !show_password"
                  >
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="password2"
                    :append-icon="show_password2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show_password2 ? 'text' : 'password'"
                    dense
                    label="Confirm Password"
                    :rules="[rules.required, rules.minlen, passwordsMatchRule]"
                    @click:append="show_password2 = !show_password2"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>

          <v-btn color="primary" :disabled="!form_is_valid" @click="createUser">
            <v-icon left>mdi-plus</v-icon> Create User</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import axios from 'axios';

export default {
  props: {},
  data: () => ({
    dialog: false,
    full_name: '',
    email: '',
    institution: '',
    password: '',
    password2: '',
    show_password: false,
    show_password2: false,
    rules: {
      required: v => !!v || 'Required.',
      minlen: v => v.length >= 8 || 'Min 8 characters.',
    },
    form_is_valid: false,
  }),
  computed: {},
  methods: {
    async createUser() {
      const request_data = {
        email: this.email,
        name: this.full_name,
        institution: this.institution,
        password: this.password,
      };
      axios.post('/api/users', request_data).then(({ _data }) => {
        this.$emit('userCreated', true);
      });
      this.dialog = false;
    },
    dialogClicked() {
      this.dialog = !this.dialog;
    },
    passwordsMatchRule(v) {
      return v === this.password || "Passwords don't match.";
    },
  },
};
</script>

<style lang="scss" scoped></style>
